import { render, staticRenderFns } from "./RegulationListItem.vue?vue&type=template&id=42cedfc0&"
import script from "./RegulationListItem.vue?vue&type=script&lang=js&"
export * from "./RegulationListItem.vue?vue&type=script&lang=js&"
import style0 from "./RegulationListItem.vue?vue&type=style&index=0&id=42cedfc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports